import { PERIOD } from '../constants';

export const DROPDOWNDATA = [
    {
        key: PERIOD.THIS_MONTH,
        label: 'This Month',
        id: 1,
    },
    {
        key: PERIOD.TODAY,
        label: 'Today',
        id: 2,
    },
    {
        key: PERIOD.THIS_YEAR,
        label: 'This Year',
        id: 3,
    },
    {
        key: PERIOD.LAST_YEAR,
        label: 'Last Year',
        id: 4,
    },
    {
        key: PERIOD.CUSTOM,
        label: 'Custom',
        id: 5,
    },
];

export const MODEDROPDOWN = [
    {
        key: 'indi',
        label: 'Individual',
        id: 'indi',
    },
    {
        key: 'team',
        label: 'Team',
        id: 'team',
    },
];
